"use strict";

exports.__esModule = true;
exports.HistogramTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _history = require("history");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _Device = require("../../Device");
var _ReportingPeriodContext = require("../../Time/ReportingPeriod/ReportingPeriodContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _AdvancedDataSources = require("../AdvancedDataTable/AdvancedDataSources");
var _timeline = require("../AdvancedDataTable/AdvancedDataSources/timeline");
var _MetricDataTable = require("../MetricTable/MetricDataTable");
var _MetricDataTableController = require("../MetricTable/MetricDataTableController");
var _createDurationRangeList = require("./createDurationRangeList");
var _createHistogramQuery = require("./createHistogramQuery");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var has = require("ramda").has;
var flatten = require("ramda").flatten;
function updateQuery(start, end, devices, durationRangeList, dataSource, query, setQuery, additionalFilters) {
  return function () {
    var newQuery = (0, _createHistogramQuery.createHistogramQuery)({
      start: start,
      end: end,
      devices: devices,
      durationRangeList: durationRangeList,
      dataSource: dataSource,
      additionalFilters: additionalFilters
    });
    if (!(0, _reactFastCompare["default"])(newQuery, query)) {
      setQuery(newQuery);
    }
  };
}
var HistogramTableElement = exports.HistogramTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  // Create a helper function that will be used to format a single cell value based on the column type
  var children = props.children,
    dataRange = props.dataRange,
    durationRange = props.durationRange,
    dataSource = props.dataSource,
    height = props.height,
    width = props.width,
    path = props.path,
    pageSizes = props.pageSizes,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection;
  var _React$useState = _react["default"].useState(null),
    query = _React$useState[0],
    setQuery = _React$useState[1];

  // contexts
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var deviceContext = _react["default"].useContext(_Device.DeviceContext);
  var devicesList = _react["default"].useContext(_Device.DeviceListContext);
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var devices = (0, _Device.getSelectedDevices)({
    urlFilter: urlFilter,
    deviceContext: deviceContext,
    defaultDeviceList: devicesList,
    selection: selection,
    dataRange: dataRange
  });
  var durationRangeList = (0, _createDurationRangeList.createDurationRangeList)(durationRange);
  var reportingPeriod = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext);
  var timePeriod = (0, _TimePeriodController.getTimePeriod)(reportingPeriod, selection, dataRange);
  var start = new Date(timePeriod.interval.startMillis).toISOString();
  var end = new Date(timePeriod.interval.endMillis).toISOString();
  var _React$useContext = _react["default"].useContext(_AdvancedDataSources.AdvancedDataSourceContext),
    loaded = _React$useContext.loaded,
    fetching = _React$useContext.fetching,
    error = _React$useContext.error,
    advDataSource = _React$useContext.data;
  if (error || fetching || !loaded) {
    return setQuery(null);
  }
  var additionalFilters = [];
  if (dataRange === "SELECTION" && selection && selection.selected) {
    var _columns = (0, _timeline.getTimelineColumns)(advDataSource.timelineDefinitions, dataSource);
    if (_columns) {
      _columns.forEach(function (col) {
        var id = col.id;

        // We only want to update entity.*, dimensions.* and measures.* column names
        var field = id.split(".")[1];
        if (field && has(field, selection.selected)) {
          var selectedValue = flatten([selection.selected[field]]);
          additionalFilters.push({
            filterType: "terms",
            fieldName: id,
            values: selectedValue
          });
        }
      });
    }
  }
  (0, _react.useEffect)(updateQuery(start, end, devices, durationRangeList, dataSource, query, setQuery, additionalFilters), [timePeriod, devices, durationRangeList, dataSource, additionalFilters]);

  // Columns are configured on child elements but rendered by the table so gather up the configs
  var columns = children.map(function (child) {
    return Object.assign({}, child.props);
  });
  var commonProps = {
    dataRange: dataRange || "",
    height: height,
    width: width,
    style: {
      height: height + "px",
      width: width + "px"
    },
    path: path,
    pageSizes: pageSizes,
    configuration: {
      overFetchAll: true,
      defaultPageSize: 25,
      enablePagination: true
    },
    filters: {}
  };
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    return /*#__PURE__*/_react["default"].createElement(_MetricDataTable.MetricDataTable, _extends({}, props, commonProps, {
      query: query,
      columns: columns,
      data: [],
      loading: false,
      sortIndex: (0, _formatColumns.getSortIndex)(columns),
      noDataText: "Make selection to view data"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_MetricDataTableController.MetricDataTableController, _extends({}, props, {
    query: query,
    columns: columns
  }), function (_ref) {
    var data = _ref.data,
      loading = _ref.loading,
      reload = _ref.reload;
    return /*#__PURE__*/_react["default"].createElement(_MetricDataTable.MetricDataTable, _extends({}, props, commonProps, {
      query: query,
      columns: columns,
      data: data,
      loading: loading,
      sortIndex: (0, _formatColumns.getSortIndex)(columns),
      reload: reload
    }));
  });
});